import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { ptBR } from '@mui/x-data-grid/locales';
import { IMovimentacaoHistoryItem } from './types';
import { cpfMask } from "utils/cpf";
import dayjs from "dayjs";

type Props = {
  data: IMovimentacaoHistoryItem[];
}

export function TableView({ data }: Props) {
  const realColumns: GridColDef<(typeof realRows)[number]>[] = [
    { field: "personName", headerName: "Nome da pessoa", width: 250 },
    { field: "pessoaJuridica", headerName: "Pessoa jurídica", width: 250 },
    { field: "personTaxPayerId", headerName: "CPF beneficiário", width: 150 },
    { field: "personType", headerName: "Tipo pessoa", width: 120 },
    { field: "personBirthDate", headerName: "Data nascimento", width: 150 },
    { field: "employeeName", headerName: "Nome funcionário", width: 250 },
    { field: "employeeTaxPayerId", headerName: "CPF funcionário", width: 150 },
    { field: "employeePosition", headerName: "Cargo", width: 200 },
    { field: "employeeHiringDate", headerName: "Data admissão", width: 150 },
    { field: "employeeDismissalDate", headerName: "Data demissão", width: 150 },
    { field: "employeeCity", headerName: "Cidade funcionário", width: 200 },
    { field: "employeeRegistrationNumber", headerName: "Matrícula", width: 150 },
    { field: "movementType", headerName: "Tipo movimento", width: 150 },
    { field: "plan", headerName: "Plano", width: 200 },
    { field: "planExclusionDate", headerName: "Data exclusão plano", width: 170 },
    { field: "executionDate", headerName: "Data execução", width: 150 },
    { field: "dagRunId", headerName: "DAG Run ID", width: 200 },
  ];

  const realRows = data.map((row, index) => ({
    id: index + 1,
    personName: row?.personName ?? '-',
    pessoaJuridica: row?.isPersonLegalEntity ?? '-',
    personTaxPayerId: !!row?.personTaxPayerId ? cpfMask(row.personTaxPayerId) : '-',
    personType: row?.personType === "employee" ? "Titular" : row?.personType === "dependent" ? "Dependente" : '-',
    personBirthDate: !!row?.personBirthDate ? dayjs(row.personBirthDate).format("DD/MM/YYYY") : '-',
    employeeName: row?.employeeName ?? '-',
    employeeTaxPayerId: !!row?.employeeTaxPayerId ? cpfMask(row.employeeTaxPayerId) : '-',
    employeePosition: row?.employeePosition ?? '-',
    employeeHiringDate: !!row?.employeeHiringDate ? dayjs(row.employeeHiringDate).format("DD/MM/YYYY") : '-',
    employeeDismissalDate: !!row?.employeeDismissalDate ? dayjs(row.employeeDismissalDate).format("DD/MM/YYYY") : '-',
    employeeCity: row?.employeeCity ?? '-',
    employeeRegistrationNumber: row?.employeeRegistrationNumber ?? '-',
    movementType: row?.movementType === "exclusion" ? "Exclusão" : row?.movementType === "inclusion" ? "Inclusão" : '-',
    plan: row?.plan ?? '-',
    planExclusionDate: row?.movementType === "exclusion" && !!row?.planExclusionDate ? dayjs(row.planExclusionDate).format("DD/MM/YYYY") : '-',
    executionDate: !!row?.executionDate ? dayjs(row.executionDate).format("DD/MM/YYYY HH:mm") : '-',
    dagRunId: row?.dagRunId ?? '-',
  }));

  return (
    <DataGrid
      rows={realRows}
      columns={realColumns}
      initialState={{
        pagination: {
          paginationModel: {
            pageSize: 25,
          },
        },
      }}
      pageSizeOptions={[10, 25, 50, 100]}
      disableRowSelectionOnClick
      style={{ backgroundColor: "white", minHeight: 400 }}
      localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
      // autoHeight
    />
  )
}